export enum TipoMov {
    Entrada = 1,
    Saida = 2
  }
  

export const getDescricaoTipoMov = (value) => {
  switch (parseInt(value)) {
    case 1:
      return 'Entrada';
    case 2:
      return 'Saída';
  }
};